import React from 'react';
import PriceTotalBlock from '../../../molecules/price/PriceTotalBlock';

const MRRoomFooter = ({
  className, children, currency, amount, taxInfo, loyalty,
}) => (
  <div
    className={`flex flex-wrap justify-between items-end |  text-primary text-base shadow ${
      className || ''
    }`}
  >
    <div>
      {children}
    </div>
    <PriceTotalBlock
      amount={amount}
      currency={currency}
      loyalty={loyalty}
      className="self-end | -mr-8 -mb-8 | text-3xl"
    >
      {/*  eslint-disable react/no-danger */ }
      <div className="hotel-ecotax text-xs" dangerouslySetInnerHTML={{ __html: taxInfo }} />
      {/* eslint-enable react/no-danger */}
      </PriceTotalBlock>
  </div>
);

export default MRRoomFooter;
